import { getToken } from "firebase/messaging";
import { messaging } from "../../firebaseconfig";

export const generateFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (token) {
      console.log("🔥 FCM TOKEN:", token);
      return token;
    } else {
      console.log("No token available");
    }
  } catch (error) {
    console.error("Error getting token:", error);
  }
};